import { render } from "./PageSelect.vue?vue&type=template&id=950e4c78&ts=true"
import script from "./PageSelect.vue?vue&type=script&lang=ts"
export * from "./PageSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__